import React from 'react';
import { Navigate, Route } from 'react-router-dom';

import LoadingPage from '@components/templates/loading-page';

import { SELLER_AREA_HOME_PATH } from './home-path';
import { customerBaseRoutes } from './routes/customer-base-routes';
import { pricingRoutes } from './routes/pricing-routes';
import { simulatorRoutes, simulatorStandaloneRoutes } from './routes/simulator-routes';

const SellerAreaRoot = React.lazy(() => import('./seller-area-root'));
const SellerAreaLayout = React.lazy(() => import('@seller-area/components/templates/main-layout'));

export const sellerAreaRoutes = (): JSX.Element[] => [
  <Route
    key="seller-area"
    element={
      <React.Suspense fallback={<LoadingPage />}>
        <SellerAreaRoot />
      </React.Suspense>
    }
  >
    <Route element={<SellerAreaLayout />}>
      <Route path="/" element={<Navigate to={SELLER_AREA_HOME_PATH} replace />} />
      {simulatorRoutes()}
      {customerBaseRoutes()}
      {pricingRoutes()}
    </Route>
    {simulatorStandaloneRoutes()}
  </Route>,
];
